// extracted by mini-css-extract-plugin
export default {"container":"ProfilePage_container__HxbYv","delete_btn":"ProfilePage_delete_btn__irdcj","btn_container":"ProfilePage_btn_container__x2roi"};